import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Droppable } from 'react-beautiful-dnd';
import TableContext from '../../TableContext';
const Tree = function Tree(props) {
    const { children, value } = props;
    const { prefixCls, columnsDragRender = {}, tableStore: { columnDraggable } } = useContext(TableContext);
    const { droppableProps, renderClone } = columnsDragRender;
    return columnDraggable ? (React.createElement(Droppable, Object.assign({ droppableId: `tree__--__${value}`, key: "tree", renderClone: renderClone ? (provided, snapshot, rubric) => renderClone({ provided, snapshot, rubric }) : undefined }, droppableProps), (droppableProvided) => (React.createElement("div", Object.assign({ ref: droppableProvided.innerRef, className: `${prefixCls}-customization-tree` }, (droppableProvided && droppableProvided.droppableProps)),
        children,
        droppableProvided && droppableProvided.placeholder)))) : (React.createElement("div", { className: `${prefixCls}-customization-tree` }, children));
};
Tree.displayName = 'Tree';
export default observer(Tree);
